import { PanelBody, SelectControl, RangeControl } from '@wordpress/components';
import { PanelColorSettings } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';

const LAYOUT_OPTIONS = [
	{ label: __( 'Top', 'brandy-blocks' ), value: 'top' },
	{ label: __( 'Left', 'brandy-blocks' ), value: 'left' },
	{ label: __( 'Right', 'brandy-blocks' ), value: 'right' },
];

const WEIGHT_OPTIONS = [
	{ label: '400', value: 400 },
	{ label: '500', value: 500 },
	{ label: '600', value: 600 },
	{ label: '700', value: 700 },
	{ label: '800', value: 800 },
];

export default function StyleControls( { attributes, setAttributes } ) {
	const isNumber = attributes.type === 'number';

	return (
		<PanelBody
			title={ __( 'Style', 'brandy-blocks' ) }
			initialOpen={ false }
		>
			{ isNumber && (
				<SelectControl
					__nextHasNoMarginBottom
					__next40pxDefaultSize
					label={ __( 'Layout', 'brandy-blocks' ) }
					value={ attributes.layout }
					options={ LAYOUT_OPTIONS }
					onChange={ ( v ) => setAttributes( { layout: v } ) }
				/>
			) }
			<RangeControl
				__nextHasNoMarginBottom
				label={ __( 'Number font size', 'brandy-blocks' ) }
				value={ attributes.numberFontSize }
				onChange={ ( v ) => setAttributes( { numberFontSize: v } ) }
				min={ 12 }
				max={ 120 }
			/>
			<SelectControl
				__nextHasNoMarginBottom
				__next40pxDefaultSize
				label={ __( 'Number font weight', 'brandy-blocks' ) }
				value={ attributes.numberFontWeight }
				options={ WEIGHT_OPTIONS }
				onChange={ ( v ) =>
					setAttributes( { numberFontWeight: Number( v ) } )
				}
			/>
			<RangeControl
				__nextHasNoMarginBottom
				label={ __( 'Title font size', 'brandy-blocks' ) }
				value={ attributes.titleFontSize }
				onChange={ ( v ) => setAttributes( { titleFontSize: v } ) }
				min={ 10 }
				max={ 48 }
			/>
			<PanelColorSettings
				title={ __( 'Colors', 'brandy-blocks' ) }
				initialOpen={ false }
				disableCustomColors={ false }
				colorSettings={ [
					{
						value: attributes.numberColor,
						onChange: ( v ) =>
							setAttributes( { numberColor: v } ),
						label: __( 'Number', 'brandy-blocks' ),
					},
					{
						value: attributes.titleColor,
						onChange: ( v ) =>
							setAttributes( { titleColor: v } ),
						label: __( 'Title', 'brandy-blocks' ),
					},
				] }
			/>
		</PanelBody>
	);
}
